export enum CATEGORIES_API {
  LIST = '/api/categories',
  GET_BY_ID = '/api/categories',
}

export enum PRODUCTS_API {
  LIST = '/api/products/category',
  SEARCH_LIST = '/api/products/search',
}